import axios from 'axios';
import Cookies from 'js-cookie';
import { getBackendApiUrl } from '../utils/BackendUrl';

const api = axios.create({
  baseURL: `${getBackendApiUrl()}/api/v1`,  
  timeout: 3000000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = Cookies.get('authToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});


api.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
